import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-login',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      style="display: flex; justify-content: center; align-items: center; height: 100vh; background: #1a1a1a; color: white;"
    >
      <div style="text-align: center;">
        <h2>Authenticating...</h2>
        <p>Please wait while we log you in.</p>
      </div>
    </div>
  `,
})
export class LoginComponent implements OnInit {
  private oidcSecurityService = inject(OidcSecurityService);
  private router = inject(Router);

  ngOnInit(): void {
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      if (isAuthenticated) {
        // Retrieve the stored URL with query params
        const redirectUrl = sessionStorage.getItem('auth_redirect_url');
        sessionStorage.removeItem('auth_redirect_url');

        if (redirectUrl) {
          // Extract path and query params from the stored URL
          try {
            const url = new URL(redirectUrl);
            const pathWithQuery = url.pathname + url.search;
            this.router.navigateByUrl(pathWithQuery);
          } catch {
            this.router.navigate(['/']);
          }
        } else {
          this.router.navigate(['/']);
        }
      }
    });
  }
}
